Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeNcss = void 0;

var merge_ncss_table_1 = require("./merge-ncss-table");

exports.mergeNcss = function (ncssObjects) {
  var result = {};
  ncssObjects.forEach(function (ncssObject) {
    if (!ncssObject.ncss) {
      return;
    }

    Object.keys(ncssObject.ncss).forEach(function (key) {
      if (merge_ncss_table_1.mergeNcssTable[key]) {
        merge_ncss_table_1.mergeNcssTable[key].forEach(function (cssProp) {
          ncssObject.ncss[cssProp] = ncssObject.ncss[key];
        });
        delete ncssObject.ncss[key];
      }
    });
    Object.assign(result, ncssObject.ncss);
  });
  return {
    ncss: result
  };
};